<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <div class="container-refresh-session">
        <div class="wrap-refresh-session">
            <div class="row justify-content-md-center mt-3">
                <div class="col-md-auto">
                    <i class="fas fa-user-clock fa-5x"></i>
                </div>
            </div>
            <div class="row justify-content-md-center mt-3">
                <div class="col-md-auto">
                    <p [innerHTML]="message"></p>
                    @if(berror) {
                    <p class="p-custom-message" [innerHTML]="messageLogin"></p>
                    }
                </div>
            </div>
            <form class="form-signin refresh-session-body" [formGroup]="loginForm"  (ngSubmit)="login()">
                <div class="form-group">
                    <div class="input-group mt-3">
                        <span class="input-group-prepend"><i class="fas fa-key"></i></span>
                        <input class="form-control-refresh-session" required="" type="password" placeholder="Contraseña"
                            formControlName="password"
                            [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" />
                        @if(submitted && f['password'].errors)
                        {
                        <div class="invalid-feedback">
                            @if(f['password'].errors['required']){
                            <div>La contraseña es requerida</div>
                            }

                        </div>
                        }

                    </div>
                </div>
                <div class="row justify-content-md-center mt-3">
                    <div class="col-md-auto">
                        <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{ cancelText
                            }}
                        </button>
                    </div>
                    <div class="col-md-auto">
                        <button [disabled]="loading" type="submit" class="btn btn-add">{{ confirmText
                            }}
                            @if(loading) {
                            <i class="fa fa-spinner fa-spin"></i>
                            <span>Validando... </span>
                            }

                        </button>
                    </div>
                </div>
                <br />
            </form>
        </div>
    </div>
</div>